import { Typography, Grid } from "@mui/material"
import Breadcrumb from '../../components/Breadcrumbs/Breadcrumbs';
import { Card, CardContent, Box, Button } from "@mui/material";
import AddIcon from '@mui/icons-material/Add';
import {
  useAppDispatch,
  useAppSelector,
} from "../../store/hooks";
import { useNavigate } from "react-router-dom";
import { PermissionsEnum } from "../../utils/auth.types";
import DashboardCards from "../../components/ARAPDashboard/DashboardCards";
import DashboardTabs from "../../components/ARAPDashboard/DashboardTabs";
import Charts from "../../components/Charts/Charts";
import ProgressCards from "../../components/ARAPDashboard/ProgressCards";
import Filters from '../../components/Filters/Filters';
import { useEffect, useState } from "react";
import { fetchAPDashboardAging, fetchAPDashboardCustomersDelay, fetchAPDashboardCustomersDue, fetchAPDashboardDSOTrend, fetchAPDashboardInvoices, fetchAPDashboardNumbers, fetchAPDashboardSales } from "../../store/APDashboardStore/APDashboardThunk";
import { ApiStatus } from "../../utils/api.types";

const AP = () => {
  const dispatch = useAppDispatch();
  const { numbers, sales, invoices, aging, DSOTrend, customerDue, customerDelay } = useAppSelector(state => state.APDashboard);
  const { selectedAccount } = useAppSelector(state => state.auth);
  const [filters, setFilters] = useState('');
  const [customerDueList, setCustomerDueList] = useState<any>(null);
  const [customerDelayList, setCustomerDelayList] = useState<any>(null);

  const dashBoardType = "AP";

  const filterOnChangeHandler = (data: any) => {
    setFilters(data);
  };

  useEffect(() => {
    if(filters) {
      const getDashboardNumbers = async () => {
        try {
          const data = await dispatch(fetchAPDashboardNumbers({accountId:selectedAccount._id, params:filters}));
        } catch (e) {
          // console.log('getDashboardNumbers Error: ', e);
        }
      }

      const getDashboardSales = async () => {
        try {
          const data = await dispatch(fetchAPDashboardSales({accountId:selectedAccount._id, params:filters}));
        } catch (e) {
          // console.log('getDashboardNumbers Error: ', e);
        }
      }

      const getDashboardInvoices = async () => {
        try {
          const data = await dispatch(fetchAPDashboardInvoices({accountId:selectedAccount._id, params:filters}));
        } catch (e) {
          // console.log('getDashboardInvoices Error: ', e);
        }
      }

      const getDashboardAging = async () => {
        try {
          const data = await dispatch(fetchAPDashboardAging({accountId:selectedAccount._id, params:filters}));
        } catch (e) {
          // console.log('getDashboardAging Error: ', e);
        }
      }

      const getDashboardDSOTrend = async () => {
        try {
          const data = await dispatch(fetchAPDashboardDSOTrend({accountId:selectedAccount._id, params:filters}));
        } catch (e) {
          // console.log('getDashboardDSOTrend Error: ', e);
        }
      }

      const getDashboardCustomerDue = async () => {
        try {
          const data = await dispatch(fetchAPDashboardCustomersDue({accountId:selectedAccount._id, params:filters}));
        } catch (e) {
          // console.log('getDashboardCustomerDue Error: ', e);
        }
      }

      const getDashboardCustomerDelay = async () => {
        try {
          const data = await dispatch(fetchAPDashboardCustomersDelay({accountId:selectedAccount._id, params:filters}));
        } catch (e) {
          // console.log('getDashboardCustomerDelay Error: ', e);
        }
      }

      getDashboardNumbers();
      getDashboardSales();
      getDashboardInvoices();
      getDashboardAging();
      getDashboardDSOTrend();
      getDashboardCustomerDue();
      getDashboardCustomerDelay();
    }
  }, [dispatch, selectedAccount, filters]);

  useEffect(() => {

    if (customerDelay.status === ApiStatus.SUCCESS) {
      setCustomerDelayList(customerDelay.dashboardCustomerDelay.list);
    }

  }, [customerDelay]);

  useEffect(() => {

    if (customerDue.status === ApiStatus.SUCCESS) {
      setCustomerDueList(customerDue.dashboardCustomerDue.list);
    }

  }, [customerDue]);

  return (
    <>
      <Breadcrumb />
      <Box sx={{ minHeight: '70vh', width: "100%", marginTop: '24px' }}>
        <div style={{ display: "flex", marginBottom: '20px'}}>
          <Filters type={'dashboard'} filterHandler={filterOnChangeHandler} />
        </div>
        <DashboardCards details={numbers.dashboardNumbers} />
        <Charts 
          salesData={sales}
          invoicesData={invoices}
          agingData={aging}
          DSOTrendData={DSOTrend}
          userType={'AP'}
        />
        <Grid container sx={{ mb: '10px' }} spacing={{ xs: 1, md: 1 }}>
          <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
            {customerDueList && <ProgressCards title="Top 5 purchasers with amount due" details={customerDueList} />}
          </Grid>
          <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
            {customerDelayList && <ProgressCards title="Top 5 purchasers by delay" details={customerDelayList} />}
          </Grid>
          {/* <Grid item xs={4} sm={4} md={6}>
            <ProgressCards />
          </Grid> */}
        </Grid>
        {filters && <DashboardTabs filter={filters} type={'AP'} /> }
      </Box>
    </>
  );
};
export default AP;